import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import AuthProvider, { useAuth } from './Auth'; 
import Login from './Login';
import PrivacyPolicy from "./PrivacyPolicy";
import Register from './Register';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import BookPreview from './BookPreview';
import SolutionViewer from './SolutionViewer';
import AutoGenerator from './AutoGenerator';
import PricingPage from './PricingPage';
import AdminSettings from './AdminSettings';
import LandingPage from './LandingPage'; 
import CoverGenerator from './CoverGenerator';
import SudokuChallenge from "./SudokuChallenge";
// === Default Games ===
import MazeBoard from './MazeBoard';
import SudokuBoard from './SudokuBoard';
import WordSearchBoard from './WordSearchBoard';
import MathBoard from './MathBoard';
import WordScrambleBoard from './WordScrambleBoard';
import NumberPyramidBoard from './NumberPyramidBoard';
import BingoBoard from './BingoBoard';
import CrosswordBoard from './CrosswordBoard';
import SnakesBoard from './SnakesBoard';
import JigsawBoard from './JigsawBoard';

// === Dynamic Games Registry ===
import * as Registry from './games_registry'; 

import './App.css';

// --- Layout Component ---
const AppLayout = ({ bookPages }) => {
  const { user, logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="app-container">
      <button className="menu-btn" onClick={() => setIsSidebarOpen(true)}>?</button>
      <div className={`overlay ${isSidebarOpen ? 'show' : ''}`} onClick={() => setIsSidebarOpen(false)}></div>
      
      <Sidebar 
        pageCount={bookPages.length} 
        isOpen={isSidebarOpen} 
        closeMenu={() => setIsSidebarOpen(false)} 
        onLogout={logout} 
        user={user} 
      />
      
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
};

// --- Protected Routes ---
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

const ProRoute = ({ children }) => {
  const { user } = useAuth();
  if (user && (['admin', 'super_user', 'pro'].includes(user.role))) return children;
  return <Navigate to="/pricing" replace />;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user && (['admin', 'super_user'].includes(user.role))) return children;
  return <Navigate to="/" replace />;
};

// ==========================================
// Main AppContent
// ==========================================
function AppContent() {
  const { user } = useAuth(); 
  const [bookPages, setBookPages] = useState([]);

  // 1. ??????? ?????? ???????
  useEffect(() => {
    if (user && user.id) {
      const userKey = `myBook_${user.id}`;
      const savedBook = localStorage.getItem(userKey);
      
      if (savedBook) {
        setBookPages(JSON.parse(savedBook));
      } else {
        setBookPages([]); 
      }
    } else {
      setBookPages([]); 
    }
  }, [user]);

  // 2. ??? ??????
  useEffect(() => {
    if (user && user.id) {
      const userKey = `myBook_${user.id}`;
      localStorage.setItem(userKey, JSON.stringify(bookPages));
    }
  }, [bookPages, user]);

  // 3. ????? ???? ????? (Manual)
  const addToBook = (type, img, settings = {}) => {
    const newPage = {
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      image: img,
      seed: settings.seed || Date.now(),
      settings: settings
    };
    setBookPages(prev => [...prev, newPage]);
    alert(`? ${type} added to your book!`);
  };

  // 4. ????? ?????? ????? (Auto Generator)
  const addBulkPages = (newPages) => {
      const formattedPages = newPages.map(p => ({
          ...p,
          id: p.id || Math.random().toString(36).substr(2, 9),
          seed: p.seed || Date.now()
      }));
      setBookPages(prev => [...prev, ...formattedPages]);
      // ????? ????? ??? alert ??? ???? ???????? ???
  };

  // 5. ??? ????
  const removePage = (id) => {
      if(window.confirm("Are you sure you want to remove this page?")) {
        setBookPages(prev => prev.filter((page) => page.id !== id));
      }
  };

  return (
    <Routes>
      {/* === Public Routes === */}
      <Route path="/" element={<LandingPage />} /> 
      <Route path="/login" element={<Login />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/register" element={<Register />} />
      <Route path="/solutions" element={<SolutionViewer />} />
      <Route path="/sudoku-challenge" element={<SudokuChallenge />} />
      {/* === Protected Routes (Sidebar Layout) === */}
      <Route element={<AppLayout bookPages={bookPages} />}>
        
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        
        <Route path="/admin" element={<PrivateRoute><AdminRoute><AdminSettings /></AdminRoute></PrivateRoute>} />
        <Route path="/pricing" element={<PrivateRoute><PricingPage /></PrivateRoute>} />
        
        <Route path="/my-book" element={
            <PrivateRoute>
                <BookPreview pages={bookPages} removePage={removePage} />
            </PrivateRoute>
        } />

        {/* ?? ???? ??? Auto Generator ?? */}
        <Route path="/autogenerator" element={<PrivateRoute><AutoGenerator onAddBulk={addBulkPages} /></PrivateRoute>} />
        
        {/* ???? ?????? */}
        <Route path="/cover-maker" element={<PrivateRoute><CoverGenerator /></PrivateRoute>} />

        {/* Default Games */}
        <Route path="/maze" element={<PrivateRoute><MazeBoard onAddToBook={addToBook} /></PrivateRoute>} />
        <Route path="/wordsearch" element={<PrivateRoute><WordSearchBoard onAddToBook={addToBook} /></PrivateRoute>} />
        <Route path="/math" element={<PrivateRoute><MathBoard onAddToBook={addToBook} /></PrivateRoute>} />
        <Route path="/wordscramble" element={<PrivateRoute><WordScrambleBoard onAddToBook={addToBook} /></PrivateRoute>} />
        <Route path="/pyramid" element={<PrivateRoute><NumberPyramidBoard onAddToBook={addToBook} /></PrivateRoute>} />
        {/* Pro Games */}
        <Route path="/sudoku" element={<PrivateRoute><ProRoute><SudokuBoard onAddToBook={addToBook} /></ProRoute></PrivateRoute>} />
        <Route path="/bingo" element={<PrivateRoute><ProRoute><BingoBoard onAddToBook={addToBook} /></ProRoute></PrivateRoute>} />
        <Route path="/crossword" element={<PrivateRoute><ProRoute><CrosswordBoard onAddToBook={addToBook} /></ProRoute></PrivateRoute>} />
        <Route path="/snakes" element={<PrivateRoute><ProRoute><SnakesBoard onAddToBook={addToBook} /></ProRoute></PrivateRoute>} />
        <Route path="/jigsaw" element={<PrivateRoute><ProRoute><JigsawBoard onAddToBook={addToBook} /></ProRoute></PrivateRoute>} />

        {/* Dynamic Games from Registry */}
        {Registry && Object.keys(Registry).map(key => {
            if(key === '_init') return null;
            const GameComponent = Registry[key];
            const path = `/${key.toLowerCase().replace('board', '')}`;
            return (
                <Route key={key} path={path} element={
                    <PrivateRoute>
                        <GameComponent onAddToBook={addToBook} />
                    </PrivateRoute>
                } />
            );
        })}

      </Route>

      {/* 404 Redirect to Landing Page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// ==========================================
// Main App Wrapper
// ==========================================
function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;